import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWaterRightsStatusList as getWaterRightsStatusListApi,
	getWaterRightsStatusListQuery as getWaterRightsStatusListQueryApi,
	getWaterRightsStatus as getWaterRightsStatusApi,
	addNewWaterRightsStatusApi,
	updateWaterRightsStatusApi,
	deleteWaterRightsStatusApi,
	checkWaterRightsStatusExistsApi,
} from '../../helpers/water_rights_status/api_helper';

export const getWaterRightsStatusList = createAsyncThunk(
	'waterRightsStatus/getWaterRightsStatusList',
	async () => {
		try {
			const response = await getWaterRightsStatusListApi();
			// Interceptor returns the API body directly. Handle both array and paginated { data: [], meta: {} } formats.
			return Array.isArray(response) ? response : (response?.data || response || []);
		} catch (error) {
			toast.error('Error al obtener los estados de derecho de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getWaterRightsStatusListQuery = createAsyncThunk(
	'waterRightsStatus/getWaterRightsStatusListQuery',
	async params => {
		try {
			const response = getWaterRightsStatusListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getWaterRightsStatus = createAsyncThunk(
	'waterRightsStatus/getWaterRightsStatus',
	async water_rights_status_id => {
		try {
			const response = await getWaterRightsStatusApi(water_rights_status_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el estado de derecho de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewWaterRightsStatus = createAsyncThunk(
	'waterRightsStatus/addNewWaterRightsStatus',
	async water_rights_status => {
		try {
			const response = await addNewWaterRightsStatusApi(water_rights_status);
			toast.success('Estado de Derecho de Agua agregado exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el estado de derecho de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateWaterRightsStatus = createAsyncThunk(
	'waterRightsStatus/updateWaterRightsStatus',
	async water_rights_status => {
		try {
			const response = await updateWaterRightsStatusApi(water_rights_status);
			toast.success('Estado de Derecho de Agua actualizado exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el estado de derecho de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteWaterRightsStatus = createAsyncThunk(
	'waterRightsStatus/deleteWaterRightsStatus',
	async water_rights_status => {
		try {
			const response = await deleteWaterRightsStatusApi(water_rights_status._id);
			toast.success('Estado de Derecho de Agua eliminado exitosamente.', {
				autoClose: 3000,
			});
			return water_rights_status;
		} catch (error) {
			toast.error('Error al eliminar el estado de derecho de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkWaterRightsStatusExists = createAsyncThunk(
	'waterRightsStatus/checkWaterRightsStatusExists',
	async name => {
		try {
			const response = await checkWaterRightsStatusExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
